import { render, staticRenderFns } from "./second-foremost.vue?vue&type=template&id=3a4f1ee6&scoped=true&"
import script from "./second-foremost.vue?vue&type=script&lang=js&"
export * from "./second-foremost.vue?vue&type=script&lang=js&"
import style0 from "./second-foremost.vue?vue&type=style&index=0&id=3a4f1ee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f1ee6",
  null
  
)

export default component.exports